import { SET_USER_PREFERENCE } from '../actions/types';

const initialState = {
  userPreference: {},
};

const userPreferencesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USER_PREFERENCE:
      return { ...state, userPreference: payload };
    default:
      return state;
  }
};

export default userPreferencesReducer;
